import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Card, Group, Loader, Stack, Text } from "@mantine/core";

import { EmptyMessage } from "@components/shared";

export default function RoleAdmins({ roleId }) {
  const { t } = useTranslation();
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdmins();
  }, [roleId]);

  function fetchAdmins() {
    setLoading(true);
    axios
      .get(`/roles/${roleId}/admins/`)
      .then(({ data }) => {
        setAdmins(data.response || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  if (loading) {
    return (
      <Group justify="center" py="xl">
        <Loader size="sm" />
      </Group>
    );
  }

  return (
    <Stack gap="xs">
      <Text fw={700}>
        {t("admin_plural")} ({admins.length})
      </Text>
      {!admins.length && <EmptyMessage />}
      {admins.map((admin) => (
        <Card key={admin.id} component={Link} to={`/admins/${admin.id}`}>
          <Text fw={700} c="dark">
            {admin.first_name} {admin.last_name}
          </Text>
        </Card>
      ))}
    </Stack>
  );
}
